import React from "react";
import ReactDOM from "react-dom";
import { Snackbar, Alert, Grid, Divider } from "@mui/material";

const CustomAlert = (message, title = "Powiadomienie", severity = "info") => {
    const container = document.createElement("div");
    document.body.appendChild(container);

    const isDark = typeof document !== 'undefined' && (
        document.documentElement.getAttribute('data-theme') === 'dark' ||
        localStorage.getItem('themeMode') === 'dark'
    );

    const effectiveSeverity = (
        severity === "info" && typeof title === "string" && (
            title.toLowerCase().includes("zmian") ||
            title.toLowerCase().includes("sukces") ||
            title.toLowerCase().includes("zaktualizowa")
        )
    ) ? "success" : severity;

    const closeAlert = () => {
        ReactDOM.unmountComponentAtNode(container);
        document.body.removeChild(container);
    };

    ReactDOM.render(
        <Snackbar
            open={true}
            autoHideDuration={5000}
            onClose={closeAlert}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
            <Alert
                onClose={closeAlert}
                severity={effectiveSeverity}
                sx={{
                    width: "100%",
                    borderRadius: "10px",
                    boxShadow: isDark ? "0 8px 24px rgba(0, 0, 0, 0.4)" : "0 4px 16px rgba(0, 0, 0, 0.1)",
                    ...(isDark && effectiveSeverity === "success" && {
                        backgroundColor: "#14532d !important",
                        background: "linear-gradient(135deg, #064e3b 0%, #14532d 100%) !important",
                        color: "#f0fdf4 !important",
                        border: "1px solid #16a34a !important",
                        '& .MuiAlert-icon': {
                            color: '#4ade80 !important',
                        },
                        '& .MuiAlert-message': {
                            color: '#f0fdf4 !important',
                        },
                        '& strong': {
                            color: '#ffffff !important',
                        },
                    }),
                    ...(isDark && effectiveSeverity === "error" && {
                        backgroundColor: "#7f1d1d !important",
                        background: "linear-gradient(135deg, #450a0a 0%, #7f1d1d 100%) !important",
                        color: "#fef2f2 !important",
                        border: "1px solid #dc2626 !important",
                        '& .MuiAlert-icon': {
                            color: '#f87171 !important',
                        },
                    }),
                    ...(isDark && effectiveSeverity === "warning" && {
                        backgroundColor: "#78350f !important",
                        background: "linear-gradient(135deg, #451a03 0%, #78350f 100%) !important",
                        color: "#fffbeb !important",
                        border: "1px solid #d97706 !important",
                        '& .MuiAlert-icon': {
                            color: '#fbbf24 !important',
                        },
                    }),
                    ...(isDark && effectiveSeverity === "info" && {
                        backgroundColor: "#1e3a8a !important",
                        background: "linear-gradient(135deg, #172554 0%, #1e3a8a 100%) !important",
                        color: "#eff6ff !important",
                        border: "1px solid #2563eb !important",
                        '& .MuiAlert-icon': {
                            color: '#60a5fa !important',
                        },
                    }),
                }}
            >
                <Grid container direction="column" spacing={2}>
                    <Grid item>
                        <strong>{title}</strong>
                    </Grid>
                    <Grid item>
                        <div style={{ whiteSpace: "pre-line", maxHeight: "400px", overflowY: "auto", marginTop: "10px" }}>
                            {Array.isArray(message) ? (
                                message.length ? (
                                    message.map((item, index) => <p key={index}>• {item} <Divider></Divider></p>)
                                ) : (
                                    <p>Brak danych do wyświetlenia...</p>
                                )
                            ) : (
                                <>
                                    <p>{message}</p>
                                </>
                            )}
                        </div>

                    </Grid>

                </Grid>
            </Alert>
        </Snackbar>,
        container
    );
};

export { CustomAlert };